import axios from "axios"
export const addLocation = (token, locationData) => {
    return axios.post(process.env.REACT_APP_API_URL + '/addLocation', locationData,
        {
            headers: {
                'Authorization': `${token}`
            }
        });
}